import React, { useState } from 'react';
import { Briefcase, Heart, Lightbulb, Handshake, CheckCircle, Mail } from 'lucide-react';
import { workWithUs, currentInterns } from '../data/mock';
import workwithusHero from "../assets/images/workwithusBg.webp";

const WorkWithUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    interest: 'intern',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your interest! We will get back to you soon.');
    setFormData({ name: '', email: '', phone: '', interest: 'intern', message: '' });
  };

  const getIcon = (id) => {
    const icons = {
      intern: Briefcase,
      volunteer: Heart,
      research: Lightbulb,
      collaborate: Handshake
    };
    return icons[id] || Briefcase;
  };

  return (
    <div className="min-h-screen pt-20">
      {/* Hero */}
      <section className="gradient-hero-saffron py-20"
        style={{
          backgroundImage: `
      linear-gradient(to bottom, rgba(255,247,230,0.95), rgba(192, 119, 51, 0.9)),
      url('${workwithusHero}')
    `,
          backgroundPosition: "center",
          backgroundSize: "contain",
        }}
      >
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center space-y-6">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground font-serif">
              Work With Us
            </h1>
            <p className="text-xl text-muted-foreground">
              Join our community of scholars, researchers, and knowledge seekers
            </p>
          </div>
        </div>
      </section>

      {/* Opportunities */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto space-y-12">
            {workWithUs.map((opportunity, index) => {
              const Icon = getIcon(opportunity.id);

              return (
                <div
                  key={opportunity.id}
                  id={opportunity.id}
                  className={`scroll-mt-24 ${index % 2 === 0 ? 'bg-gradient-to-br from-white to-secondary/20' : 'bg-white'
                    } rounded-2xl shadow-lg p-8 md:p-12 border border-primary/10`}
                >
                  <div className="flex flex-col md:flex-row gap-8 items-start">
                    <div className="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Icon className="w-8 h-8 text-primary" />
                    </div>

                    <div className="flex-1">
                      <h2 className="text-3xl font-bold text-foreground mb-4 font-serif">
                        {opportunity.title}
                      </h2>
                      <p className="text-lg text-muted-foreground leading-relaxed mb-6">
                        {opportunity.description}
                      </p>

                      {opportunity.requirements && (
                        <div className="mb-6">
                          <h3 className="font-bold text-foreground mb-3">Requirements:</h3>
                          <ul className="space-y-2">
                            {opportunity.requirements.map((req, idx) => (
                              <li key={idx} className="flex items-start gap-2">
                                <CheckCircle className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                                <span className="text-muted-foreground">{req}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      {opportunity.benefits && (
                        <div className="mb-6">
                          <h3 className="font-bold text-foreground mb-3">Benefits:</h3>
                          <ul className="space-y-2">
                            {opportunity.benefits.map((benefit, idx) => (
                              <li key={idx} className="flex items-start gap-2">
                                <CheckCircle className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                                <span className="text-muted-foreground">{benefit}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      {opportunity.contact && (
                        <div className="bg-primary/10 p-4 rounded-lg">
                          <p className="text-sm font-semibold text-foreground mb-2">
                            For inquiries:
                          </p>
                          <a
                            href={`mailto:${opportunity.contact}`}
                            className="text-primary font-semibold flex items-center gap-2 hover:underline"
                          >
                            <Mail className="w-4 h-4" />
                            {opportunity.contact}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Current Interns Section */}
      {/* <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">

            {/* Heading *}
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold font-serif text-foreground">
                Meet Our Current Interns
              </h2>
              <p className="text-muted-foreground mt-2">
                Dedicated individuals contributing to our mission and projects
              </p>
            </div>

            {/* Grid *}
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10">
              {currentInterns.map((intern) => (
                <div
                  key={intern.id}
                  className="group relative bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden"
                >

                  {/* Top Gradient Strip *}
                  <div className="h-20 bg-gradient-to-r from-orange-400 to-orange-600"></div>

                  {/* Profile Image *}
                  <div className="flex justify-center -mt-12">
                    <img
                      src={intern.image}
                      alt={intern.name}
                      className="w-24 h-24 rounded-full border-4 border-white object-cover shadow-md group-hover:scale-105 transition"
                      onError={(e) => {
                        e.target.src = "/images/default-avatar.png";
                      }}
                    />
                  </div>

                  {/* Content *}
                  <div className="text-center px-6 pb-6 pt-3">

                    {/* Name *}
                    <h3 className="text-lg font-bold text-foreground">
                      {intern.name}
                    </h3>

                    {/* Role *}
                    <p className="text-primary font-semibold text-sm">
                      {intern.role}
                    </p>

                    {/* Divider *}
                    <div className="w-10 h-[2px] bg-primary mx-auto my-3"></div>

                    {/* Info badges *}
                    <div className="space-y-2 text-sm text-muted-foreground">
                      <p>🕒 {intern.duration}</p>
                      <p>📌 {intern.project}</p>
                    </div>

                    {/* Button *}
                    <a
                      href={intern.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block mt-4 px-4 py-2 text-sm font-semibold text-white bg-primary rounded-full hover:bg-orange-600 transition"
                    >
                      View Profile
                    </a>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section> */}


      {/* Application Form */}
      <section className="py-16 bg-secondary/20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
              <h2 className="text-3xl font-bold text-foreground mb-4 font-serif text-center">
                Express Your Interest
              </h2>
              <p className="text-muted-foreground text-center mb-8">
                Fill out this form and we'll get back to you shortly
              </p>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-foreground mb-2">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                      placeholder="Your full name"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-foreground mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                      placeholder="your.email@example.com"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-foreground mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    placeholder="+91 XXXXX XXXXX"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-foreground mb-2">
                    I am interested in *
                  </label>
                  <select
                    required
                    value={formData.interest}
                    onChange={(e) => setFormData({ ...formData, interest: e.target.value })}
                    className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                  >
                    <option value="intern">Internship</option>
                    <option value="volunteer">Volunteering</option>
                    <option value="research">Research Fellowship</option>
                    <option value="collaborate">Collaboration</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-foreground mb-2">
                    Message / Statement of Purpose
                  </label>
                  <textarea
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    rows={5}
                    className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    placeholder="Tell us about yourself and why you're interested..."
                  />
                </div>

                <button type="submit" className="w-full btn-saffron">
                  Submit Application
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-br from-primary to-orange-600 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center space-y-6">
            <h2 className="text-3xl font-bold font-serif">
              Questions About Working With Us?
            </h2>
            <p className="text-xl text-white/90">
              Feel free to reach out - we'd love to hear from you
            </p>
            <a
              href="mailto:vaciks@maitreyi.du.ac.in"
              className="inline-flex items-center gap-2 bg-white text-primary font-bold px-8 py-4 rounded-full hover:bg-gray-100 transition-all hover:scale-105 shadow-xl"
            >
              <Mail className="w-5 h-5" />
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WorkWithUs;
